module.exports = __webpack_public_path__ + "assets/img/protocol.b7ec6bfa.png";